module.exports = __webpack_public_path__ + "static/media/pontics.ac9bcc98.svg";